const radius = 40;
const diameter = radius * 2;
const circumference = Math.PI * diameter;
const circlePercentage = (percentage) => circumference * (percentage / 100);

const percentageChart = (percentage) => [
  ['save'],
  ['circle', [0, 0, radius]],
  ['lineWidth', [7.5]],
  ['fillAndStroke', ['#fff', '#a1a1a1']],
  ['circle', [0, 0, radius]],
  ['lineWidth', [7.5]],
  ['dash', [circlePercentage(percentage), {
    // Offset to the start of the stroke to the top of the circle
    phase: circlePercentage(75), // 25(%) === 45 degrees
    space: circumference - circlePercentage(percentage)
  }]],
  ['stroke', ['#1fd1a1']],
  ['fontSize', [24]],
  ['font', ['Helvetica']],
  ['fillColour', ['#a1a1a1']],
  ['text', [`${percentage}%`, -radius, -8, { align: 'center', width: diameter }]],
  ['restore']
];

export default percentageChart;



// WEBPACK FOOTER //
// ./src/reports/partials/percentage-chart.js